import ButtonCardContainer from './ButtonCardContainer';
import ButtonCardUI from './ButtonCardUI';

const ButtonCard = {
    Container: ButtonCardContainer,
    UI: ButtonCardUI
};

export default ButtonCard;
